//
import { required, number } from "@/services/validations"
const valid = (num)=>{
  if(parseInt(num)>12){
    return true
  }
  else{
    return false
  }
}
export default [
  {
      text: 'Linea #',
      value: 'line_number',
      width: '5%',
  },
  {
      text: 'código interno',
      value: 'internal_code',
      width: '10%',
  },
  {
      text: 'nombre',
      value: 'name',
      width: '15%',
  },
  {
      text: 'cantidad',
      value: 'quantity',
      align: 'right',
      format: 'number',
      input: {
          reverse: true,
          type: 'float-field',
          trigger(ctx, props) {
            //console.log(props.item.subtotal,'subtotal')
              props.item.subtotal = parseInt(props.item.quantity) * (props.item.price_with_discount)
              props.item.update = true
          },
          
      },
      width: '5%',
  },
  {
      text: 'precio neto',
      value: 'price_with_discount',
      align: 'right',
      format: 'currency',
      input: {
          type: 'currency-field',
          reverse: true,
          trigger(ctx, props) {
            props.item.subtotal = parseInt(props.item.quantity) * (props.item.price_with_discount) 
            props.item.update = true   
          },
      },
      width: '10%',
  },
  // {
  //     text: 'dscto/recarga línea',
  //     value: 'global_discount_line_amount',
  //     align: 'right',
  //     format: 'currency',
  //     input: {
  //         type: 'currency-field',
  //         reverse: true,
  //         // trigger(ctx, props) {
  //         //     props.item.net_total =
  //         //         props.item.quantity * props.item.net_price +
  //         //         props.item.global_discount_line_amount
  //         // },
  //     },
  //     width: '10%',
  // },
  {
      text: 'subtotal',
      value: 'subtotal',
      align: 'right',
      format: 'currency',
      // input: {
      //     type: 'currency-field',
      //     reverse: true,
      // },
      width: '10%',
  },
  {
    text: 'saldo Subtotal',
    value: 'saldo_subtotal',
    align: 'rigth',
    format: 'currency',
    width: '10%',
  },
  {
    text: 'Retornar stock',
    value: 'stock_return',
    align: 'center',
    format: 'boolean',
    input: {
      style: {
        justifyContent: 'center',
      },
      change(ctx, props) {
        
        //
        const tableSelected = Object.keys(ctx.$refs.table.selected)
        const tableIndex    = tableSelected.findIndex(id => id === props.item.id.toString())
        
        //
        if (props.item.stock_return) {
          ctx.$refs['input-price_with_discount'][tableIndex].$children[0].$refs.input.setAttribute('readonly', '')
          props.item.price_with_discount = props.item.price_with_discount_stored
        } else {
          ctx.$refs['input-price_with_discount'][tableIndex].$children[0].$refs.input.removeAttribute('readonly')
        }
      },
      type: 'switch',
    },
    width: '10%',
  },
]
